import { urlPathnameToLocationName } from '@/features/shared/analytics/utils'
import { AnalyticsEvent } from '@shipt/analytics-member-web'
import { track } from '@/features/shared/analytics/trackingQueue'

export enum PromotionScopeType {
  coupon = 'coupon',
  featured_promotion = 'featured promotion',
}

export const trackSponsoredContentLoaded = ({
  beaconUrl,
  featuredTransactionID,
  adPlacementId,
}: {
  beaconUrl: string
  featuredTransactionID: string
  adPlacementId?: string
}) => {
  track({
    eventName: AnalyticsEvent.SponsoredContentLoaded,
    properties: {
      location: urlPathnameToLocationName(),
      beacon_url: beaconUrl,
      featured_transaction_id: featuredTransactionID,
      ad_placement_id: adPlacementId,
    },
  })
}
